function moveSubcat(){

    if($('html[lang="sk"]').length){
        var zobrazProdukty = 'Voir les produits'
    }
    else{
        var zobrazProdukty = 'View products'
    }
    
    $('.category-top .breadcrumbs').remove()
    $('.category-top').prepend($('.breadcrumbs').clone());
    
    $('html[lang="sk"] .breadcrumbs a[href="/sk/"]').text('Maison')
    if($('.subcategories').length){
        $('.subcategories li a').each(function(){
            $(this).find('img').attr('src', $(this).find('img').attr('src').replace('/thumb/', '/orig/'))
            if(!$(this).find('.pseudoButton').length){
                $(this).find('.text').append('<span class="pseudoButton">'+zobrazProdukty+'</span>')
            }
            
        })
        $('.category-top').after($('.subcategories'))

    }
}



$(document).ready(function() {
    moveSubcat()
  })
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    moveSubcat()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    moveSubcat();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    moveSubcat();
});